<template>
  <div class="account-ipt">
    <div class="left-part short-input">
      <input class="input"  :class="{'error':errMsgShow}" placeholder="图片验证码" v-model="imgCode" maxlength="4" v-on:blur="imgCodeBlur()" v-on:focus="imgCodeFocus()"/>
    </div>
    <div class="right-part"><img :src='imgSrc' @click="imgCodeChange"/></div>
    <div class="msg-box" v-show="errMsgShow&&!isMobile">
      <div class="icon"></div>
      <div class="text color-msg font-size12">{{errMsg}}</div>
    </div>
  </div>
</template>
<script>
  import {mtvConfig as CONF, mtvServers as server} from '../services/services'
  export default {
    props: ['options', 'imgCodeErrData'],
    data () {
      return {
        imgCode: '',
        imgSrc: '',
        errMsgShow: false,
        errMsg: '',
        isMobile: false
      }
    },
    created () {
      this.isMobile = server.isMobile()
      this.imgSrc = this.options.imgSrc + '?' + new Date().getTime()
    },
    watch: {
      options: function (newValue, oldValue) {
        this.imgCodeChange()
        this.errMsgShow = false
      },
      imgCode: function (newValue, oldValue) {
        let that = this
        that.$emit('imgCodeSuccess', newValue)
        if (newValue.length === 4) {
          if (this.imgCodeBlur()) {
            if (this.options.inputType !== CONF.inputType.mobileOrEmail) {
              this.errMsgShow = false
              server.appServices(this, this.options.sendUrl, {mobile: this.options.mobile, ncode: this.options.ncode, imgcode: this.imgCode}).then(res => {
                if (res.status === CONF.errCode.success.code) {
                  that.errmsgShow = false
                  that.$emit('mobileCodeSendSuccess', that.options.isVoice)
                } else {
                  this.showErrMsg(CONF.errCode['code' + res.status].msg)
                  that.imgCodeChange()
                  that.imgCode = ''
                }
              })
            }
          }
        } else if (newValue.length === 0) {
          if (this.options.inputType === CONF.inputType.mobileOrEmail) {
            that.$emit('imgCodeSuccess', newValue)
          }
        }
      },
      imgCodeErrData (newValue) {
        this.imgCodeChange()
        this.showErrMsg(newValue.errMsg)
      }
    },
    methods: {
      imgCodeBlur () {
        if (this.imgCode.length === 0) {
          return
        }
        if (!CONF.reg.imgCode.test(this.imgCode)) {
          this.showErrMsg(CONF.errorMsg.format.imgCode)
          return false
        }
        return true
      },
      imgCodeFocus () {
        this.errMsgShow = false
      },
      imgCodeChange () {
        this.imgSrc = this.options.imgSrc + '?' + new Date().getTime()
        this.imgCode = ''
      },
      showErrMsg (msg) {
        if (this.isMobile) {
          this.$toast({toastMsg: msg})
        }
        this.errMsgShow = true
        this.errMsg = msg
      }
    }
  }
</script>



// WEBPACK FOOTER //
// imgCode.vue?2722ddd2